import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { Page } from "../api.types";
import { IOrganization } from "../organizations";
import { IProfileUpdate, IUser } from "../users";
const API = `${API_URL}/profile`;

export const getProfile = async () => {
    const result: { data: IUser } = await axios.get(`${API}`);
    return result.data;
};

export const updateProfile = async (data: IProfileUpdate) => {
    const result: { data: IUser } = await axios.put(`${API}`, data);
    return result.data;
};

export const deleteProfile = async () => {
    const result = await axios.delete(`${API}`);
    return result.data;
};

export const readUserOrganizations = async (
    page: number = 1,
    size: number = 50
) => {
    const url = buildUrl(`${API}/organizations`, { page, size });
    const result = await axios.get<Page<IOrganization>>(url);
    return result.data;
};
